(() => {
  'use strict';
  const normalise = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const categories = [
    ['motor', /\b(motor[a-z]*|moteur|torque|koppel|couple)\b/],
    ['battery', /\b(battery|batterij[a-z]*|accu|batterie|range|actieradius|autonomie|charger|lader|chargeur)\b/],
    ['brakes', /\b(brake|brakes|rem|remmen|remtype|frein|freins)\b/],
    ['wheels', /\b(wheel|wheels|wiel|wielen|wielgrootte|rim|rims|velg|velgen|tire|tires|tyre|tyres|band|banden|dynamo|dynamonaaf|roue|roues|jante|jantes|pneu|pneus)\b/],
    ['cockpit', /\b(handlebar|handlebars|stem|stuur|sturen|stuurpen|display|guidon|potence|ecran)\b/],
    ['saddle', /\b(saddle|seat|seatpost|zadel|zadelpen|zadelpennen|selle)\b/],
    ['lights', /\b(light|lights|lighting|headlight|taillight|verlichting|voorlicht|achterlicht|eclairage|phare|feu)\b/],
    ['accessories', /\b(lock|slot|balhoofdslot|rack|carrier|voordrager|voorpakdrager|bagagedrager|accessories|accessoires|antivol|bagages|mudguard|fender|spatbord)\b/],
    ['drive', /\b(gear|gears|versnellingen|versnelling|gearing|transmission|drivetrain|aandrijving|kettingkast|chain|chaincase|belt|riem|derailleur|vitesse|vitesses|chaine|courroie)\b/],
    ['frame', /\b(frame|frametype|framemaat|cadre|fork|voorvork|fourche|weight|gewicht|poids)\b/],
    ['general', /\b(model|color|colour|kleur|couleur|year|jaar|annee|support|ondersteuning|assistance|manual|handleidingen|options|opties)\b/]
  ];
  function init(root) {
    const specs = root.querySelector('.oxford-specifications');
    if (!specs || specs.dataset.initialised) return;
    specs.dataset.initialised = 'true';
    const nav = specs.querySelector('.oxford-specifications__versions');
    function syncVersions() {
      const source = root.querySelector('[data-option="modelGears"] .m-product-options__values');
      if (!source) return;
      const links = [...source.querySelectorAll('a[href]')];
      nav.replaceChildren(...links.map(link => {
        const copy = link.cloneNode(true);
        copy.removeAttribute('role');
        return copy;
      }));
      nav.hidden = links.length < 2;
    }
    root.addEventListener('oxford:executions', syncVersions);
    syncVersions();
    let labels;
    try { labels = JSON.parse(specs.querySelector('.oxford-specifications__labels').textContent); }
    catch (_) { return; }
    const groups = new Map(Object.keys(labels).map(key => [key, []]));
    const tables = [];
    // Only transform simple two-column attribute tables; preserve all other content.
    specs.querySelectorAll('.oxford-specifications__source table').forEach(table => {
      const rows = [...table.rows];
      if (!rows.length || rows.some(row => row.cells.length !== 2 || [...row.cells].some(cell => cell.colSpan > 1 || cell.rowSpan > 1))) return;
      const data = rows.filter(row => ![...row.cells].every(cell => cell.tagName === 'TH'));
      if (!data.length) return;
      data.forEach(row => {
        const key = normalise(row.cells[0].textContent);
        const group = categories.find(([, pattern]) => pattern.test(key));
        groups.get(group ? group[0] : 'other').push(row.cloneNode(true));
      });
      tables.push(table);
    });
    if (!tables.length) return;
    const fragment = document.createDocumentFragment();
    groups.forEach((rows, key) => {
      if (!rows.length) return;
      const details = document.createElement('details');
      details.className = 'oxford-specifications__group';
      details.open = true;
      const summary = document.createElement('summary');
      summary.textContent = labels[key];
      const table = document.createElement('table');
      table.setAttribute('aria-label', labels[key]);
      const body = document.createElement('tbody');
      rows.forEach(row => body.append(row));
      table.append(body);
      details.append(summary, table);
      fragment.append(details);
    });
    specs.querySelector('.oxford-specifications__groups').append(fragment);
    tables.forEach(table => table.remove());
    specs.querySelectorAll('.oxford-specifications__extra').forEach(details => {
      const source = details.querySelector('.oxford-specifications__source');
      if (!source.textContent.trim() && !source.querySelector('img,video,iframe,table')) details.hidden = true;
    });
  }
  const run = () => document.querySelectorAll('.oxford-product-page').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
